import React from 'react'
import { FormSection } from 'redux-form'
import { Divider, Button, Icon } from 'antd'
import ContactForm from './ContactForm'

const Contact = ({ sendMessage }) => {
  const handleSubmit = event => {
    event.preventDefault()

    if(sendMessage){
      sendMessage()
    }
  }

  return (
    <div>
      <div className="inner-wrapper">
        <div className="steps-content">
          <div className="steps-header">
            <h3>Contact Us</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <Divider>Get in touch</Divider>
            <div className='form-section-div'>
              <FormSection name="contactForm">
                <ContactForm />
              </FormSection>
            </div>
            <Button
              shape="round"
              className="success-btn content-submit-btn"
              htmlType="submit"
            >
              <Icon type="export" /> Send
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Contact
